// extracted by mini-css-extract-plugin
export var arrowIcon = "components-breadcrumb-__Breadcrumb-module___arrowIcon";
export var breadcrumb = "components-breadcrumb-__Breadcrumb-module___breadcrumb";
export var breadcrumbItem = "components-breadcrumb-__Breadcrumb-module___breadcrumbItem";
export var breadcrumbItemActive = "components-breadcrumb-__Breadcrumb-module___breadcrumbItemActive";